import { FieldInput } from "@/components/form/field-input";
import { FieldSelect } from "@/components/form/field-select";
import { FieldTextarea } from "@/components/form/field-textarea";

interface MasterParamFormFieldsProps {
  isDisabled?: boolean;
}

export function MasterParamFormFields({
  isDisabled = false,
}: MasterParamFormFieldsProps) {
  return (
    <>
      <FieldInput
        name="paramType"
        label="Param Type"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
        uppercase={true}
      />
      <FieldTextarea
        name="value"
        label="Value"
        description="Value should be unique in the same Param Type"
        hasRequiredAsterisk={!isDisabled}
        isDisabled={isDisabled}
      />
      <FieldTextarea
        name="description"
        label="Description"
        isDisabled={isDisabled}
      />
      <FieldSelect
        name="active"
        label="Status"
        isDisabled={isDisabled}
        hasRequiredAsterisk={!isDisabled}
        options={[
          { label: "Active", value: "true" },
          { label: "Non Active", value: "false" },
        ]}
      />
      <FieldInput
        name="paramTag"
        label="Param Tag"
        isDisabled={isDisabled}
        uppercase={true}
      />
      <FieldInput name="value2" label="Value 2" isDisabled={isDisabled} />
    </>
  );
}
